import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';
import 'bootstrap';
import router from './router';
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate';
import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import './registerServiceWorker'
import InputField from './components/forms/InputField.vue'
import ButtonField from './components/forms/ButtonField.vue'
import PasswordField from './components/forms/PasswordField.vue'
import CheckboxField from './components/forms/CheckboxField.vue'
import BaseTable from './components/widgets/BaseTable.vue'
import { Dropdown } from 'floating-vue'
import OptionActionDataTable from './components/widgets/OptionActionDataTable.vue'

// Componentes Admin
import NavBarLeftAdmin from './components/admin/layout/NavBarLeftAdmin.vue';
import ButtonNavBarAdmin from './components/admin/layout/ButtonNavBarAdmin.vue';
import HeaderPage from './components/admin/layout/HeaderPage.vue';
import AdminPage from './components/admin/layout/AdminPage.vue';

import Vue3Toastify, { toast } from 'vue3-toastify';
import VueGoodTablePlugin from 'vue-good-table-next';
import FloatingVue from 'floating-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import Multiselect from '@vueform/multiselect';
import SelectField from './components/forms/SelectField.vue';
import PlataformaBadge from './components/global/PlataformaBadge.vue';
import FilterBadge from './components/global/FilterBadge.vue';
import FilterBadgeGroup from './components/global/FilterBadgeGroup.vue';
import StatusBadge from './components/global/StatusBadge.vue';
import LabelBadge from './components/forms/LabelField.vue';
import TextareaField from './components/forms/TextareaField.vue';
import AvatarField from './components/global/AvatarField.vue';

// --- Componentes User (Lista) ---
import NavBarLeftUser from './components/app/layout/NavBarLeftUser.vue';
import ButtonNavBarUser from './components/app/layout/ButtonNavBarUser.vue';
import ListUser from './components/app/layout/list/ListUser.vue';
import ChatItem from './components/app/layout/list/ChatItem.vue';
import ChatList from './components/app/layout/list/ChatList.vue';
import GroupItem from './components/app/layout/list/GroupItem.vue';
import ListTabs from './components/app/layout/list/ListTabs.vue';
import ListSearchFilter from './components/app/layout/list/ListSearchFilter.vue';
import ListHeader from './components/app/layout/list/ListHeader.vue';
import GroupList from './components/app/layout/list/GroupList.vue';

// --- Componentes User (Chat) - NOVOS ---
import AreaChatUser from './components/app/layout/chat/AreaChatUser.vue';
import ChatHeader from './components/app/layout/chat/ChatHeader.vue';
import ChatConversation from './components/app/layout/chat/ChatConversation.vue';
import ChatMessage from './components/app/layout/chat/ChatMessage.vue';
import ChatInput from './components/app/layout/chat/ChatInput.vue';
import ChatEmpty from './components/app/layout/chat/ChatEmpty.vue';
import { branding } from '@/config/branding';

// ------------------ CSS ---------------
import '@/assets/css/bootstrap.min.css';
import '@/assets/css/app.min.css';
import '@/assets/css/branding.css';
import '@/assets/css/dark-mode-overrides.css';
// Tokens dos selos do admin (FilterBadge / StatusBadge). Global porque a paleta
// é compartilhada entre componentes e a variante escura mora em `body`.
import '@/assets/css/badges.css';
import '@/assets/css/vue-virtual-scroller.css';
// ⬆️  a maracutaia acima substitui isso: import 'vue-virtual-scroller/index.css'
import 'remixicon/fonts/remixicon.css';
import 'vue3-toastify/dist/index.css';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import 'floating-vue/dist/style.css';
import 'sweetalert2/dist/sweetalert2.min.css';
// Estilo dos SweetAlerts de escolha em cards (src/utils/waConnectSwal.ts).
// Global porque o SweetAlert monta fora da árvore de componentes.
import '@/assets/css/wa-connect-popup.css';
import '@/assets/css/importacao-swal.css';
// Âncora do menu de ações das tabelas do admin (src/utils/table-row-context-menu.composable.ts).
import '@/assets/css/table-menu-anchor.css';
import '@/assets/css/tooltips.css';
import '@/assets/css/rodizio.css';
import '@/assets/css/transicoes.css';
import '@/assets/css/poppers-enquete.css';
import '@vueform/multiselect/themes/default.css';
import 'v-calendar/style.css';
// Design System da área admin (tokens `--adm-*`, casca, tabelas, modais, menus).
// Por último de propósito: sobrescreve o tema da vue-good-table e do multiselect.
import '@/assets/css/admin.css';

import ChatProfileSidebar from './components/app/layout/chat/ChatProfileSidebar.vue';

// NOVO: Importar o modal de etiqueta
import { vPermission, vPermissionParams } from './directives/v-permission';
import { vLiberarMidia } from './directives/v-liberar-midia';

const app = createApp(App);

// ------------------ Components ---------------
app.component('InputField', InputField)
app.component('ButtonField', ButtonField)
app.component('PasswordField', PasswordField)
app.component('CheckboxField', CheckboxField)
app.component('NavBarLeftAdmin', NavBarLeftAdmin)
app.component('ButtonNavBarAdmin', ButtonNavBarAdmin)
app.component('HeaderPage', HeaderPage)
app.component('AdminPage', AdminPage)
app.component('BaseTable', BaseTable)
app.component('DropdownField', Dropdown)
app.component('OptionActionDataTable', OptionActionDataTable)
app.component('MultiSelect', Multiselect)
app.component('SelectField', SelectField)
app.component('PlataformaBadge', PlataformaBadge)
app.component('FilterBadge', FilterBadge)
app.component('FilterBadgeGroup', FilterBadgeGroup)
app.component('StatusBadge', StatusBadge)
app.component('LabelBadge', LabelBadge)
app.component('TextareaField', TextareaField)
// O editor de texto rico arrasta tiptap + prosemirror (~320 KiB) e é usado em
// DOIS modais do admin (novidades). Registrado globalmente com import estático,
// ele viajava no chunk de entrada de todo mundo — inclusive de quem só abre o
// chat. Registro global com componente assíncrono funciona igual; só o
// carregamento é adiado para o primeiro uso.
app.component('RichTextField', defineAsyncComponent(
    () => import('./components/forms/RichTextField.vue'),
))
app.component('AvatarField', AvatarField)


// ------------------ Components User (Lista) ---------------
app.component('NavBarLeftUser', NavBarLeftUser)
app.component('ButtonNavBarUser', ButtonNavBarUser)
app.component('ListUser', ListUser)
app.component('ChatItem', ChatItem)
app.component('ChatList', ChatList)
app.component('GroupItem', GroupItem)
app.component('GroupList', GroupList)
app.component('ListHeader', ListHeader)
app.component('ListSearchFilter', ListSearchFilter)
app.component('ListTabs', ListTabs)
app.component('ChatActionsModal', defineAsyncComponent(() => import('./components/app/layout/list/ChatActionsModal.vue')))

// ------------------ Components User (Chat)---------------
app.component('AreaChatUser', AreaChatUser)
app.component('ChatHeader', ChatHeader)
app.component('ChatConversation', ChatConversation)
app.component('ChatMessage', ChatMessage)
app.component('ChatInput', ChatInput)
app.component('ChatEmpty', ChatEmpty)
app.component('ChatProfileSidebar', ChatProfileSidebar)
app.component('AudioWaveform', ChatProfileSidebar)


// ------------------ Components User (Modals) ---------------
// Modais são ASSÍNCRONOS: registrados globalmente com import estático, os 16
// viajavam no chunk de ENTRADA — isto é, eram baixados e interpretados no boot
// por todo mundo, inclusive por quem só usa o painel de admin e nunca abre
// nenhum deles. O registro global funciona igual com componente assíncrono.
//
// ⚠️ Eles continuam sendo RENDERIZADOS sem `v-if` na PainelPage, então o módulo
// é buscado no mount dela, não na abertura do modal. O ganho aqui é tirá-los do
// boot e do chunk de entrada. Carregar de verdade só ao abrir exigiria um
// `v-if` por modal contra a flag dele no `uiStore` — mudança maior, e vários
// registram ouvintes no próprio mount.
app.component('AddTagModal', defineAsyncComponent(() => import('./components/app/modals/AddTagModal.vue'))) 
app.component('LinkTagModal', defineAsyncComponent(() => import('./components/app/modals/LinkTagModal.vue')))
app.component('ForwardModal', defineAsyncComponent(() => import('./components/app/modals/ForwardModal.vue')))
app.component('PinDurationModal', defineAsyncComponent(() => import('./components/app/modals/PinDurationModal.vue')))
app.component('AiChatModal', defineAsyncComponent(() => import('./components/app/modals/AiChatModal.vue')))
app.component('HistoryModal', defineAsyncComponent(() => import('./components/app/modals/HistoryModal.vue')))
app.component('TransferModal', defineAsyncComponent(() => import('./components/app/modals/TransferModal.vue')))
app.component('BotTriggerModal', defineAsyncComponent(() => import('./components/app/modals/BotTriggerModal.vue')))
app.component('GerarOportunidadeModal', defineAsyncComponent(() => import('./components/app/modals/GerarOportunidadeModal.vue')))
app.component('OportunidadesAxionModal', defineAsyncComponent(() => import('./components/app/modals/OportunidadesAxionModal.vue')))
app.component('VincularAxionModal', defineAsyncComponent(() => import('./components/app/modals/VincularAxionModal.vue')))
app.component('AbrirChamadoAxionModal', defineAsyncComponent(() => import('./components/app/modals/AbrirChamadoAxionModal.vue')))
app.component('ChamadosContatoAxionModal', defineAsyncComponent(() => import('./components/app/modals/ChamadosContatoAxionModal.vue')))
app.component('DispararProcessoAxionModal', defineAsyncComponent(() => import('./components/app/modals/DispararProcessoAxionModal.vue')))
app.component('ProcessosContatoAxionModal', defineAsyncComponent(() => import('./components/app/modals/ProcessosContatoAxionModal.vue')))

const pinia = createPinia()
pinia.use(piniaPersist)

const optionsAlerts = {
    confirmButtonColor: branding.colors.light.success,
    cancelButtonColor: '#ef476f',
    reverseButtons: true
}
// ------------------- Diretivas -------------------
app.directive<HTMLElement, vPermissionParams>('permission', vPermission)
app.directive<HTMLMediaElement>('liberar-midia', vLiberarMidia)

app
.use(Vue3Toastify, {
    autoClose: 3000,
    position: 'top-right',
})
.use(VueSweetalert2, optionsAlerts)
.use(router)
.use(pinia)
.use(VueGoodTablePlugin)
/*
  `whiz-rich`: tooltip de CONTEÚDO (título + corpo, mais de uma linha), usado via
  `<VTooltip theme="whiz-rich">` com slot `#popper`. Slot e não `html: true`
  porque o conteúdo carrega dado de usuário (nome de campanha) — `html: true`
  exigiria escapar à mão em cada uso, e um esquecimento é injeção.

  A aparência mora em `assets/css/tooltips.css`: o popper é teleportado, então
  `<style scoped>` não alcança.
*/
.use(FloatingVue, {
    themes: {
        'whiz-rich': {
            $extend: 'tooltip',
            placement: 'top',
            distance: 8,
            // Um pouco mais lento que o tooltip padrão: caixa maior aparecendo a
            // cada passada do mouse vira poluição.
            delay: { show: 180, hide: 100 },
        },
    },
})
.use(setupCalendar, {})
.mount('#app')

// ------------------ Componentes de calendário ------------------
app.component('VCalendar', Calendar)
app.component('VDatePicker', DatePicker)

app.config.globalProperties.$toast = toast